import _get from 'lodash-es/get';
import { phoneNumberRegex } from '../helpers';

export const getCDN = url => `https://b.zmtcdn.com${url}`;

export const getCroppedUrl = (url, width, height, factor = 2) => {
  const fWidth = width * factor;
  const fHeight = height * factor;
  const hasParams = url.indexOf('?') >= 0;
  const cropParam = `fit=around|${fWidth}:${fHeight}&crop=${fWidth}:${fHeight};*,*`;
  return hasParams ? `${url}&${cropParam}` : `${url}?${cropParam}`;
};

export const isNonEmptyArray = arrayName =>
  Array.isArray(arrayName) && !!arrayName.length;

export const isUserLoggedIn = store => {
  let numericUserId = Number(_get(store, 'user.user_id', 0));
  numericUserId = Number.isNaN(numericUserId) ? 0 : numericUserId;
  const name = _get(store, 'user.name', '');
  // const email = _get(store, 'user.email', '');
  return Boolean(numericUserId && name);
};

export const validateEmail = email => {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

export const genericDomains = [
  'gmail.com',
  'yahoo.com',
  'outlook.com',
  'hotmail.com',
  'icloud.com',
];

export const validateLeadEmail = email => {
  if (!email) return false;

  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}(\.[0-9]{1,3}){3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  const isValidFormat = re.test(String(email).toLowerCase());
  if (!isValidFormat) return false;

  // Block common generic email domains
  const domain = email.split('@')[1]?.toLowerCase();
  return !genericDomains.includes(domain);
};

export const validateName = name => {
  const re = /^[a-zA-Z0-9 ()@-]+$/;
  return re.test(String(name).toLowerCase());
};

export const validatePhoneNumber = phoneNumber => {
  return phoneNumberRegex.test(String(phoneNumber));
};

export const isNumericOnly = value => {
  const numericOnlyRegex = /^\d+$/;
  return numericOnlyRegex.test(String(value));
};

export const getBrowser = () => {
  const { userAgent } = navigator;
  let browserName = 'Unknown';

  if (/chrome|chromium|crios/i.test(userAgent)) {
    browserName = 'Chrome';
  } else if (/firefox|fxios/i.test(userAgent)) {
    browserName = 'Firefox';
  } else if (/safari/i.test(userAgent)) {
    browserName = 'Safari';
  } else if (/opr\//i.test(userAgent)) {
    browserName = 'Opera';
  } else if (/edg/i.test(userAgent)) {
    browserName = 'Edge';
  }

  return browserName;
};

export const isEmployeeGstMappingEnabledForCompany = () => {
  return true; // you can change this if you want to enable/disable the feature for specific workspace
};

export const isEmployeeAdditionButtonDisabled = (
  selectedWorkspace,
  viewOnlyMode,
) => {
  if (selectedWorkspace && selectedWorkspace.workspace_id) {
    return (
      viewOnlyMode ||
      !isEmployeeGstMappingEnabledForCompany(selectedWorkspace.workspace_id)
    );
  }
  return false;
};
